import { render, staticRenderFns } from "./ManageExtrasCharges.vue?vue&type=template&id=601bd02b"
import script from "./ManageExtrasCharges.vue?vue&type=script&lang=js"
export * from "./ManageExtrasCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports